import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Navbar.module.css';
import { useCredits } from 'contexts/CreditsContext';

const formatNum = (n) => (n ?? 0).toLocaleString();

const Navbar = () => {
    const { balance, isUnlimited } = useCredits();

    return (
<nav className={styles.navbar}>
    <div className={styles.content}>
        <Link to="/search">
            <img className={styles.logo} src={process.env.PUBLIC_URL + '/logo.png'} alt="Logo" />
        </Link>
    </div>
    <Link to="/search" className={styles.content}>
        <div className={styles.menuicon}>
            <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.5 6a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-.6 4.3 3.2 3.2a.8.8 0 0 1-1.1 1.1l-3.2-3.2a4.5 4.5 0 1 1 1.1-1.1Z"
            />
            </svg>
        </div>
        <span className={styles.menutext}>Search</span>
    </Link>
    <Link to="/settings" className={styles.content}>
        <div className={styles.menuicon}>
            <svg data-testid="primary-nav-item-icon" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M2.5 14.4h11a.4.4 0 0 0 .4-.4 3.4 3.4 0 0 0-3.4-3.4h-5A3.4 3.4 0 0 0 2.1 14c0 .22.18.4.4.4Zm0 1.6h11a2 2 0 0 0 2-2 5 5 0 0 0-5-5h-5a5 5 0 0 0-5 5 2 2 0 0 0 2 2ZM8 6.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8ZM8 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"></path></svg>
        </div>
        <span className={styles.menutext}>Settings</span>
    </Link>


    <Link to="/api" className={styles.content}>
            <div className={styles.menuicon}>
                <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.714 6.693a.75.75 0 1 0 1.106 1.014l2.933-3.2a.75.75 0 0 0 0-1.013L10.82.294a.75.75 0 1 0-1.106 1.013l1.781 1.943H4.6A3.75 3.75 0 0 0 .85 7v.067a.75.75 0 1 0 1.5 0V7A2.25 2.25 0 0 1 4.6 4.75h6.895l-1.78 1.943ZM6.286 9.307A.75.75 0 0 0 5.18 8.293l-2.932 3.2a.75.75 0 0 0 0 1.014l2.932 3.2a.75.75 0 1 0 1.106-1.014l-1.78-1.942H11.4A3.75 3.75 0 0 0 15.15 9v-.067a.75.75 0 0 0-1.5 0V9a2.25 2.25 0 0 1-2.25 2.25H4.505l1.78-1.944Z"></path>
                </svg>
            </div>
            <span className={styles.menutext}>API</span>
    </Link>

    <Link to="/mcp" className={styles.content}>
            <div className={styles.menuicon}>
                <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 1v3M11 1v3M5 12v3M11 12v3M3 4h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
            <span className={styles.menutext}>MCP</span>
    </Link>

    <Link to="/upgrade" className={styles.content}>
            <div className={styles.menuicon}>
                <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 1.5v13M3 6.5 8 1.5l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
            <span className={styles.menutext}>Upgrade</span>
    </Link>

    <Link to="/support" className={styles.content}>
            <div className={styles.menuicon}>
                <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Zm0 3.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm-.75 4.25h1.5v3.5h-1.5v-3.5Z" stroke="currentColor" strokeWidth="0.5" fill="currentColor"/>
                </svg>
            </div>
            <span className={styles.menutext}>Support</span>
    </Link>

    <Link to="/upgrade" className={styles.creditsWidget}>
        <div className={styles.creditsLabel}>Credits</div>
        <div className={styles.creditsValue}>
            {isUnlimited ? 'Unlimited' : formatNum(balance)}
        </div>
    </Link>

</nav>

     );
}

export default Navbar;
